import React, { memo } from 'react';
import { CmsImage } from 'common-ui';
import type { ImageEntryType } from 'tsconfig/types';
import ReactPlayer from 'react-player/lazy';
import type { Config as ReactPlayerConfig } from 'react-player/lazy';

// --- ReactPlayer wrapper ---
export type VimeoReactPlayerProps = {
  url: string;
  showThumbnail?: boolean;
  image?: ImageEntryType;
  onPlayPause?: () => void;
  onReadyFn?: (player: any) => void;
  className?: string;
  testId?: string;
  loop?: boolean;
  width?: string;
  height?: string;
  controls?: boolean;
  config?: ReactPlayerConfig;
};

const VimeoReactPlayer = memo(
  ({
    url,
    showThumbnail,
    image,
    onPlayPause,
    onReadyFn,
    className,
    testId,
    loop,
    width,
    height,
    controls,
    config,
  }: VimeoReactPlayerProps) => {
    const videoPlayerConfig = {
      ...config,
      vimeo: {
        ...config?.vimeo,
        playerOptions: {
          ...config?.vimeo?.playerOptions,
          dnt: true,
        },
      },
    };

    const extraPlayerProps = {
      config: videoPlayerConfig,
      ...(onPlayPause && { onEnded: () => onPlayPause() }),
      ...(onReadyFn && { onReady: (player: any) => onReadyFn(player) }),
      ...(width && { width }),
      ...(height && { height }),
      ...(image && { light: showThumbnail && <CmsImage contentItem={image} /> }),
      ...(controls && { controls }),
      ...(loop && { loop }),
      ...(className && { className }),
      ...(testId && { 'data-testid': testId }),
      ...(image && { fallback: <CmsImage contentItem={image} /> }),
    };

    return <ReactPlayer url={url} playing={true} {...extraPlayerProps} />;
  },
);

export default VimeoReactPlayer;
